// theme.ts
import "@digital-services-gard-as/anchor-css/dist/index.css";

import AnchorTokens from "@digital-services-gard-as/anchor-tokens/docs.json";
import BorderColors from "@digital-services-gard-as/anchor-tokens/src/border-colors.json";
import GlobalColors from "@digital-services-gard-as/anchor-tokens/src/global-colors.json";
import IconColors from "@digital-services-gard-as/anchor-tokens/src/icon-colors.json";
import SurfaceColors from "@digital-services-gard-as/anchor-tokens/src/surface-colors.json";
import TextColors from "@digital-services-gard-as/anchor-tokens/src/text-colors.json";

import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

import { flattenValues, filterTokens } from "@/utils/chakraThemeUtils";

const colors = {
    ...GlobalColors.a,
    ...SurfaceColors.a,
    ...TextColors.a,
    ...IconColors.a,
    ...BorderColors.a
};

const fontTokens = AnchorTokens.a.font;

const fontSizes = flattenValues(filterTokens(fontTokens, "size"));
const lineHeights = flattenValues(filterTokens(fontTokens, "line-height"));
const fontWeights = flattenValues(filterTokens(fontTokens, "weight"));
const letterSpacings = flattenValues(filterTokens(fontTokens, "tracking"));
const fontFamilies = flattenValues(filterTokens(fontTokens, "family"));

const config = defineConfig({
    theme: {
        tokens: {
            colors: { anchor: flattenValues(colors) },
            spacing: { anchor: flattenValues(AnchorTokens.a.spacing) },
            radii: { anchor: flattenValues(AnchorTokens.a.border) },
            breakpoints: { anchor: flattenValues(AnchorTokens.a.breakpoint) },
            fontSizes: { anchor: fontSizes },
            lineHeights: { anchor: lineHeights },
            fontWeights: { anchor: fontWeights },
            letterSpacings: { anchor: letterSpacings },
            fonts: { anchor: fontFamilies }
        }
    },
    globalCss: {
        ":root": { fontSize: "16px" },
        "html, body": {
            bg: "var(--a-surface-subtle)",
            color: "var(--a-text-default)",
            fontFamily: "var(--a-font-family-sans)",
            fontStyle: "normal",
            fontWeight: "var(--a-font-weight-medium)",
            lineHeight: "var(--a-font-line-height-3)"
        }
    }
});

export const system = createSystem(defaultConfig, config);
